import React, { useEffect, useState } from "react";
import { useStore } from "@/store/StoreContext";
import Diya from "./Diya";

export default function CountdownStrip() {
  const { content } = useStore();
  const [left, setLeft] = useState({ h: 24, m: 0, s: 0 });

  useEffect(() => {
    if (!content?.countdown_end) return;
    const end = new Date(content.countdown_end).getTime();
    const tick = () => {
      const diff = Math.max(end - Date.now(), 0);
      setLeft({
        h: Math.floor(diff / 3600000),
        m: Math.floor((diff % 3600000) / 60000),
        s: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [content?.countdown_end]);

  const pad = (n) => String(n).padStart(2, "0");
  const { h, m, s } = left;

  return (
    <section data-testid="diwali-countdown" className="relative py-10 lg:py-12">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 text-center sm:px-8">
        <div className="float-y mb-3"><Diya size={52} /></div>
        <h2 data-testid="countdown-title" className="font-display text-3xl font-semibold italic text-[#8F6E1D] sm:text-4xl lg:text-5xl">
          {content?.countdown_title || "Happy Diwali!"}
        </h2>
        <p className="mt-3 max-w-xl text-base leading-relaxed text-[#6B5B45]">
          {content?.countdown_subtext || "Exclusive Diwali prices are valid only for the next few hours — jaldi se apna favourite Rudraksha order kijiye."}
        </p>
        <div className="mt-7 flex items-center gap-3 sm:gap-4" data-testid="countdown-timer">
          {[[pad(h), "Hours"], [pad(m), "Minutes"], [pad(s), "Seconds"]].map(([v, l], i) => (
            <React.Fragment key={l}>
              <div className="min-w-[80px] rounded-md border border-[#B08D2B]/40 bg-white px-3 py-3 shadow-[0_14px_35px_-18px_rgba(143,110,29,0.4)] sm:min-w-[92px]">
                <p data-testid={`countdown-${l.toLowerCase()}`} className="font-display text-3xl font-bold tabular-nums text-[#8F6E1D] sm:text-4xl">{v}</p>
                <p className="mt-0.5 text-[9px] font-semibold uppercase tracking-[0.24em] text-[#6B5B45]">{l}</p>
              </div>
              {i < 2 && <span className="font-display text-3xl text-[#B08D2B]">:</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
